import React from 'react';
import PropTypes from 'prop-types';
import { Row, Image, Pressable } from 'modules/styled';

const TwitterIcon = require('public/img/twitter-black.png');
const EmailIcon = require('public/img/email.png');
const SlackIcon = require('public/img/slack.png');
const MediumIcon = require('public/img/medium.png');
const InstaIcon = require('public/img/instagram.png');

const icons = [
  {
    href: 'https://blog.relevant.community',
    source: MediumIcon,
    target: '_blank',
  },
  {
    href: 'https://instagram.com/relevant_community',
    source: InstaIcon,
    target: '_blank',
  },
  {
    href: 'https://twitter.com/relevantfeed',
    source: TwitterIcon,
    target: '_blank',
  },
  // {
  //   href:
  //     'https://join.slack.com/t/relevantcommunity/shared_invite/enQtMjIwMjEwNzUzMjUzLWVjODViM2ZkZDE5ZWMyYzcxMzI3ZTQ3Njc4YTBmYmVmMTQxZGJiNDcxYzljODZlM2U0NGU1YTE3MDlhM2I1NmI',
  //   source: SlackIcon,
  //   target: '_blank',
  // },
  {
    href: 'mailto:info@relevant.community',
    source: EmailIcon,
    target: '_blank',
  },
];

const FooterIcon = ({ href, source, target, actions }) => {
  if (!source) return null;

  return (
    <Pressable
      external
      to={href}
      onClick={() => actions.goToUrl(href)}
      target={target || '_self'}
      inline={1}
    >
      <Image
        sx={{ width: 2.8 * 8, height: 2.4 * 8, mr: 2 }}
        resizeMode={'contain'}
        source={source}
      />
    </Pressable>
  );
};

FooterIcon.propTypes = {
  href: PropTypes.string,
  source: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  target: PropTypes.string,
  actions: PropTypes.object,
};

export default function FooterIcons({ actions }) {
  return (
    <Row sx={{ mt: 2, mb: [0, 2] }}>
      {icons.map((icon) => (
        <FooterIcon actions={actions} key={icon.href} {...icon} />
      ))}
    </Row>
  );
}

FooterIcons.propTypes = {
  actions: PropTypes.object,
};
